import React, { useContext, useState } from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";

import MainLayout from '../layouts/MainLayout'
import UserInfos from '../components/UserInfos'
import TrainingDetailSection from "../components/TrainingDetailSection";
import TrainingModulesSection from "../components/TrainingModulesSection";
import TrainingExportsSection from "../components/TrainingExportsSection";
import TrainingDeletionSection from "../components/TrainingDeletionSection";
import { VIEWS_MODE } from '../constants'
import { TrainingContext } from "../services/Training";

const useQuery = () => {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const TrainingDetails = () => {
  const query = useQuery();
  const { id } = useParams();
  const [viewName, setViewName] = useState(query.get('tab') || Object.keys(VIEWS_MODE)[0])
  const [ trainingContext ] = useContext(TrainingContext)

  if(!trainingContext) {
    return <Navigate to='/training' />
  }
  
  return (
    <MainLayout>
      <div className="h-full flex flex-col">
        <div className="flex">
          <div className="flex-1">
            <h1 className="text-4xl font-semibold text-gray-800 truncate">{(trainingContext || { name: 'Fiche de formation'}).name}</h1>
            <h2 className=" text-gray-400">{(trainingContext || { reference: 'Consultez le dossier de votre formation'}).reference}</h2>
          </div>
          <UserInfos/>
        </div>
        <div className="border-b border-gray-200">
          <ul className="flex flex-wrap -mb-px text-sm  text-center text-gray-500">
              { 
                Object.keys(VIEWS_MODE).map(key =>
                  <li className="mr-2"  key={key}>
                    <button
                      className={`inline-flex p-4 rounded-t-lg ${viewName === key ? 'text-pink-600 active border-pink-600' : 'border-transparent hover:text-gray-700 hover:border-gray-300'} border-b-2 group`}
                      onClick={setViewName.bind(this, key)}
                    >
                      <span className="flex items-center justify-center font-medium">
                        {VIEWS_MODE[key].icon} {VIEWS_MODE[key].title}
                      </span>
                    </button>
                  </li>
                )
              }
          </ul>
        </div>
        <div className="flex-1 overflow-scroll">
          {
            viewName === Object.keys(VIEWS_MODE)[0] && <TrainingDetailSection id={id} />
          }
          {
            viewName === Object.keys(VIEWS_MODE)[1] && <TrainingModulesSection id={id} />
          }
          {
            viewName === Object.keys(VIEWS_MODE)[2] && <TrainingExportsSection id={id} />
          }
          {
            viewName === Object.keys(VIEWS_MODE)[3] && <TrainingDeletionSection id={id} />
          }
        </div>
      </div>
    </MainLayout>
  )
}

export default TrainingDetails
